import type { RouteContextInterface, RouterContextInterface } from '@app/packages/routing/types'

export class RouteDataExtractor {
  router: RouterContextInterface

  constructor(router: RouterContextInterface) {
    this.router = router
  }

  async extract(route: RouteContextInterface) {
    return {
      event_id: route.route.eventName.split(':')[0],
      event_data: await this.extractEventData(route),
    }
  }

  private async extractEventData(route: RouteContextInterface): Promise<Record<string, any>> {
    return (await route.route.eventData?.(this.router.location, route.params, this.router.context)) ?? {}
  }
}
